<script>
    import {calcTimeByOffset} from "../lib/Common.svelte";
    import {Constans} from "../lib/Constants";
    export let targetDate;

    let result;
    let delta = 0;
    export let complete = false;

    let refreshInterval = setInterval(() => {
        const now = calcTimeByOffset(Constans.timeZoneOffset);
        delta = Math.abs(targetDate - now.getTime()) / 1000;

        if (delta < 1 && !complete) {
            complete = true;
        }

        const days = Math.floor(delta / 86400);
        delta -= days * 86400;

        const hours = Math.floor(delta / 3600) % 24;
        delta -= hours * 3600;

        const minutes = Math.floor(delta / 60) % 60;
        delta -= minutes * 60;

        const seconds = Math.floor(delta % 60);  // in theory the modulus is not required

        result = `${minutes}:${seconds}`;
    }, 1000);

</script>

{#if delta > 0 && !complete}
    <span>(~{result})</span>
{/if}